import { useTranslation } from 'react-i18next'

import { useApiGetStores } from 'core/api/store/useApiGetStores'
import { Select } from 'antd'
import { useCallback } from 'react'
import { useGlobalFiltersStore } from '../../../../core/store/useGlobalFiltersStore'

const StoreSelect = () => {
  const { t } = useTranslation()
  const storeId = useGlobalFiltersStore(state => state.storeId)
  const setStoreId = useGlobalFiltersStore(state => state.setStoreId)

  const { data: stores, isLoading } = useApiGetStores()

  const onChange = useCallback(
    (value: number) => {
      if (!value) return
      setStoreId(value)
    },
    [setStoreId]
  )

  return (
    <Select
      showSearch={{ optionFilterProp: 'label' }}
      className="mg-header-store"
      aria-label="store choice"
      data-testid="store-select"
      placeholder={t('general.filters.selects.stores')}
      value={storeId ?? undefined}
      status={storeId ? '' : 'error'}
      onChange={onChange}
      disabled={isLoading}
      options={
        !isLoading
          ? stores.map(store => ({
              value: store.id,
              label: `${store.id} - ${store.label}`
            }))
          : []
      }
      size="medium"
    />
  )
}

export default StoreSelect
